export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        name: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        },
    },
};
